import type { Action } from './actions'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'
import type {
    ImageShortDTO,
    MarketingAnimationShortDTO,
    SuggestionShortDTO
} from 'shared/types/api'

export type State = {
    +endowments: ?Array<MarketingAnimationShortDTO>,
    +imageHeader: ?ImageShortDTO,
    +offer: ?MarketingAnimationShortDTO,
    +suggestions: ?SuggestionShortDTO,
    +footerNotice: ?MarketingAnimationShortDTO,
    dataLoaded: ?boolean,
    error?: any,
    networkError?: any
}

const initialState: State = {
    endowments: [],
    imageHeader: null,
    offer: null,
    footerNotice: null,
    suggestions: null,
    dataLoaded: false
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_FAMILY_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(state, action, endpoints.pages.family)
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
